/* SHARED */

import { IAction } from '@state/types';
import * as actionsInterfces from './types';
import * as actionTypes from './constants';

const defaultState: actionsInterfces.IAuthState = { };

const authReducer = (
  state: actionsInterfces.IAuthState = defaultState, 
  action: { } | actionsInterfces.ISetAuthAction | IAction
) => {
  switch ((action as IAction).type) {
    case actionTypes.SET_AUTH: {
      return {...defaultState, userManager: (action as actionsInterfces.ISetAuthAction).userManager, user: (action as actionsInterfces.ISetAuthAction).user, token: (action as actionsInterfces.ISetAuthAction).token};
    }
    case actionTypes.SET_SHARE_TOKEN: {
      return {...state, shareToken: (action as actionsInterfces.ISetShareTokenAction).shareToken};
    }
    case actionTypes.SERVER_ERROR: {
      return {...state, serverError: (action as actionsInterfces.IServerErrorAction).error ? (action as actionsInterfces.IServerErrorAction).error : {}};
    }
    default: {
      return state;
    }
  }
};

export default authReducer;
